import { isAfter, subDays } from "date-fns"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const DEFAULT_DAYS = 30

const graphQLFragments = {
    account: graphql(`
        fragment isAccountCreatedWithinDays_Account on AccountType {
            createdAt
        }
    `),
}

type IsAccountCreatedWithinDaysOptions = {
    /** Number of days, counted back from today, within which the account must have been created. */
    days?: number
}

export function isAccountCreatedWithinDays(
    fragment: FragmentOf<typeof graphQLFragments.account>,
    { days = DEFAULT_DAYS }: IsAccountCreatedWithinDaysOptions = {}
) {
    const account = readFragment(graphQLFragments.account, fragment)

    if (!account.createdAt) {
        return false
    }

    return isAfter(new Date(account.createdAt), subDays(new Date(), days))
}

isAccountCreatedWithinDays.fragments = graphQLFragments
